<div>
  <ng-container *ngIf="dataSource && dataSource.data.length > 0; else noRequest">
    <div>
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="propertyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bien</th>
          <td mat-cell *matCellDef="let row" class="main">{{ row.propertyName }}</td>
        </ng-container>
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Demandeur</th>
          <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.date | dateTimeFormat }}
          </td>
        </ng-container>
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Message</th>
          <td mat-cell *matCellDef="let row">{{ row.message }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="mobile-double-actions">
            <button class="mobile-inline" mat-icon-button (click)="selectRequest(row.request)"
              appTooltip="Valider la demande"><mat-icon color="primary">task_alt</mat-icon></button>
            <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSize]="paging.pagingPageSize" [pageSizeOptions]="paging.pagingPageSizeOptions"
        showFirstLastButtons></mat-paginator>
    </div>
  </ng-container>
  <ng-template #noRequest>
    <span class="no-content">Aucune demande n'est disponible</span>
  </ng-template>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <button mat-menu-item (click)="confirmDelete(row.request)">
          <mat-icon color="primary">delete_forever</mat-icon>Supprimer la demande
        </button>
      </li>
    </ul>
  </ng-template>
</mat-menu>